(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7767],{

/***/ 52479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/Button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  border-width: ",
        ";\n  border-style: solid;\n  letter-spacing: 0.3px;\n  text-transform: ",
        ";\n  width: ",
        ";\n  ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        "px;\n  display: ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  border-color: ",
        ";\n  border-color: ",
        ";\n  ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonBody = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonBody",
    componentId: "sc-989935d2-0"
})(_templateObject(), function(props) {
    return props.borderWidth || "1px";
}, function(props) {
    return props.textTransform;
}, function(props) {
    return props.fluid ? "100%" : "fit-content";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) && "width : ".concat(props === null || props === void 0 ? void 0 : props.width);
}, function(props) {
    return props.fontWeight || 500;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.display || "block";
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx, ";\n      margin-right: ").concat(props.mx, ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.variant === "outline" ? "transparent" : props.backgroundColor || "#000000";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.variant === "outline" ? props.backgroundColor : props.fontColor || "#ffffff";
}, function(props) {
    return !props.disabled && props.boxShadow;
}, function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.borderColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.whiteSpace) && "white-space: ".concat(props === null || props === void 0 ? void 0 : props.whiteSpace);
}, function(props) {
    return props.hoverEnabled && "#F8F8F8";
}, function(props) {
    return props.isDisable && "opacity: 0.5";
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js







var Button = function(props) {
    var label = props.label, args = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        children: label
    }));
};
Button.propsTypes = {
    backgroundColor: (prop_types_default()).string,
    label: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).any,
    display: (prop_types_default()).string,
    roundness: (prop_types_default()).number,
    width: (prop_types_default()).string,
    textTransform: (prop_types_default()).string,
    fontColor: (prop_types_default()).string,
    pt: (prop_types_default()).string,
    pl: (prop_types_default()).string,
    pb: (prop_types_default()).string,
    pr: (prop_types_default()).string,
    py: (prop_types_default()).string,
    px: (prop_types_default()).string,
    mt: (prop_types_default()).string,
    mb: (prop_types_default()).string,
    ml: (prop_types_default()).string,
    mr: (prop_types_default()).string,
    mx: (prop_types_default()).string,
    my: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    borderColor: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    fontSize: (prop_types_default()).number,
    variant: (prop_types_default()).string,
    whiteSpace: (prop_types_default()).string
};
/* harmony default export */ var AtomicComponents_Button = (Button);


/***/ }),

/***/ 38855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "WE": function() { return /* reexport */ CartButton/* default */.Z; },
  "rs": function() { return /* reexport */ AtomicComponents_Switch; }
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(52479);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js
var CartButton = __webpack_require__(8673);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/Switch.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: none;\n  width: ",
        ";\n  outline: none;\n  background-color: #eeeef1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n\n  color: #646464;\n\n  width: ",
        ";\n  width: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    width: 100px;\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 80px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  transform: translateY(-50%);\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 50%;\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 8px 12px;\n\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchContainer",
    componentId: "sc-3f72cec7-0"
})(_templateObject(), function(props) {
    return props.fluid ? "100%" : "fit-content";
});
var switches = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "switches",
    componentId: "sc-3f72cec7-1"
})(_templateObject1(), function(props) {
    return props.fontSize || 14;
});
var SwitchLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchLabel",
    componentId: "sc-3f72cec7-2"
})(_templateObject2(), function(props) {
    return props.width && "".concat(props.width, " !important;");
}, function(props) {
    return props.fluid && "100% !important;";
});
var SwitchToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchToggle",
    componentId: "sc-3f72cec7-3"
})(_templateObject3(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return !!props.isToggle ? "right: -5px;" : "left: -5px;";
});
var Toggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Toggle",
    componentId: "sc-3f72cec7-4"
})(_templateObject4(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness * 2);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
});

// EXTERNAL MODULE: ./src/containers/Orders/context/index.tsx
var context = __webpack_require__(60227);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/index.js





var Switch = function(props) {
    var ref = (0,react.useContext)(context/* OrderContext */.y), onChangeActiveTab = ref.onChangeActiveTab, activeTab = ref.activeTab;
    var _tabsData = props.tabsData, tabsData = _tabsData === void 0 ? [] : _tabsData, _roundness = props.roundness, roundness = _roundness === void 0 ? 2 : _roundness, _fluid = props.fluid, fluid = _fluid === void 0 ? false : _fluid, backgroundColor = props.backgroundColor, width = props.width;
    var tabRoundness = (0,util/* roundnessCalculator */.M)(roundness) || "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchContainer, {
        backgroundColor: backgroundColor,
        fluid: fluid,
        fontSize: 14,
        className: "tw-h-[48px]",
        style: {
            borderRadius: tabRoundness
        },
        children: tabsData.map(function(param) {
            var text = param.text, key = param.key;
            var isActiveTab = activeTab === key;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: width,
                onClick: function() {
                    return onChangeActiveTab(key);
                },
                isActiveTab: isActiveTab,
                className: "tw-relative tw-h-full tw-w-full tw-bg-transparent",
                style: {
                    borderRadius: tabRoundness
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isActiveTab ? "tw-absolute -tw-inset-x-[5px] -tw-inset-y-[2px] tw-z-10 tw-flex tw-items-center tw-justify-center tw-text-white" : "",
                    style: {
                        backgroundColor: isActiveTab ? backgroundColor : "transparent",
                        borderRadius: tabRoundness
                    },
                    children: text
                })
            }, key);
        })
    });
};
/* harmony default export */ var AtomicComponents_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/index.js






/***/ }),

/***/ 97767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_MemberLogin; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(56173);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
;// CONCATENATED MODULE: ./src/assets/svgExports/OtpRightArrow.js

var OtpRightArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16.031",
        height: "16.031",
        viewBox: "0 0 16.031 16.031",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Path_49",
            "data-name": "Path 49",
            d: "M-3.984-12.984H-16.172l5.578-5.625L-12-20.016-20.016-12-12-3.984l1.406-1.406-5.578-5.625H-3.984Z",
            transform: "translate(-3.984 -3.984) rotate(180)",
            fill: "#fff"
        })
    });
};

// EXTERNAL MODULE: ./src/containers/MemberLogin/MemberLogin.module.scss
var MemberLogin_module = __webpack_require__(91642);
var MemberLogin_module_default = /*#__PURE__*/__webpack_require__.n(MemberLogin_module);
// EXTERNAL MODULE: ./src/utils/sendWhatsappMessage.js
var sendWhatsappMessage = __webpack_require__(36290);
;// CONCATENATED MODULE: ./src/containers/MemberLogin/components/DesktopView.js





var DesktopView = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var handleMobileInputChange = function(e) {
        props.handleInputChange("phone", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 10);
    };
    var handleOtpInputChange = function(e) {
        props.handleInputChange("otp", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 4);
    };
    var onContactUsClick = function() {
        var ref, ref1;
        (0,sendWhatsappMessage/* sendWhatsappMessage */.i)("Hi ".concat(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.store_name, ",\n\n                         I'm unable to access your website\n                         ").concat(props === null || props === void 0 ? void 0 : (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : ref1.store_url));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MemberLogin_module_default()).desktopView,
            children: props.OTPsent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.logo_image,
                                height: "44px",
                                width: "44px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 pt16px f16px fw5 black-color",
                                children: [
                                    "Welcome to ",
                                    (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store_info) === null || ref2 === void 0 ? void 0 : ref2.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 f22px fw5 c1C1C1C pt32px",
                                children: [
                                    "OTP sent to ",
                                    props.phone
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: props.invalidOtp ? (MemberLogin_module_default()).formControlOtpInvalid : (MemberLogin_module_default()).formControlOtp,
                        value: props.OTP,
                        placeholder: "Enter 4 digit OTP",
                        onChange: handleOtpInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: 300,
                                    transform: "translate(343px , 18px)"
                                },
                                children: !props.isTimeUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "timer mt20px db",
                                    style: {
                                        transform: "translate(133px , -18px)"
                                    },
                                    children: "0:".concat(props.timer)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        width: 300,
                                        color: "#6C6C6C"
                                    },
                                    children: "Did not receive OTP?"
                                })
                            }),
                            props.isTimeUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pointer fw7 f14px relative z-1",
                                style: {
                                    transform: "translate(425px , 20px)"
                                },
                                onClick: function() {
                                    return props.resendOTP();
                                },
                                children: "Send Again"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: props.invalidOtp ? {
                            color: "red",
                            transform: "translateY(-19px)"
                        } : {
                            color: "red",
                            transform: "translateY(-19px)",
                            visibility: "hidden"
                        },
                        children: "Invalid OTP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-end justify-between",
                        style: {
                            transform: "translateY(-20px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 flex c2F80ED pointer f14px fw5",
                                    style: {
                                        paddingBottom: "1.38rem"
                                    },
                                    onClick: props.toggleOTPsent,
                                    children: "Change number?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                style: {
                                    transform: "translate(16px , 0)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                        backgroundColor: props.OTP.length === 4 && !props.invalidOtp ? "#000000" : "#00000033",
                                        roundness: (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
                                        style: {
                                            borderRadius: "4rem",
                                            borderWidth: "0px"
                                        },
                                        py: "21px",
                                        mx: "auto",
                                        mt: "81px",
                                        pr: "4rem",
                                        pl: "3rem",
                                        fontSize: 18,
                                        className: props.OTP.length === 0 ? "cursor-auto" : "",
                                        isDisable: props.OTP.length !== 4,
                                        onClick: function() {
                                            return props.submitVerifyOTP();
                                        },
                                        label: "VERIFY"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            transform: "translate(-58px, 105px)"
                                        },
                                        onClick: function() {
                                            return props.submitVerifyOTP();
                                        },
                                        className: "pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: props === null || props === void 0 ? void 0 : (ref5 = props.storeInfo) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
                                height: "44px",
                                width: "44px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 pt16px f16px fw5 black-color",
                                children: [
                                    "Welcome to ",
                                    (ref6 = props.storeInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store_info) === null || ref7 === void 0 ? void 0 : ref7.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mv0 f22px fw5 c1C1C1C pt32px",
                                children: "Login using Mobile Number"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: (MemberLogin_module_default()).formControl,
                        value: props.phone,
                        placeholder: "Enter your mobile Number",
                        onChange: handleMobileInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: props.memberOnlyAccessError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start mt16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/red-info-icon.svg",
                                    width: "14px",
                                    height: "14px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 f14px fw4 pl10px",
                                    style: {
                                        color: "#F54C52"
                                    },
                                    children: "Sorry, you don’t have permission to access this website."
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "c464646 f14px fw5 mv0 ".concat(props.memberOnlyAccessError ? "pt12px" : "pt20px"),
                        children: [
                            "For any query,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "c2F80ED",
                                style: {
                                    border: "none",
                                    cursor: "pointer",
                                    backgroundColor: "white"
                                },
                                onClick: onContactUsClick,
                                children: "Contact us"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            style: {
                                transform: "translate(16px , -22px)"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                    style: {
                                        borderRadius: "4rem",
                                        borderWidth: "0px"
                                    },
                                    backgroundColor: props.phone.length === 10 && !props.memberOnlyAccessError ? "#000000" : "#00000033",
                                    roundness: (ref8 = props.storeInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness,
                                    width: "174px",
                                    py: "24px",
                                    mx: "auto",
                                    whiteSpace: "nowrap",
                                    mt: props.memberOnlyAccessError ? "59px" : "85px",
                                    pr: "4rem",
                                    pl: "2.5rem",
                                    fontSize: 18,
                                    isDisable: props.phone && props.phone.length !== 10 || !props.phone || props.memberOnlyAccessError,
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    label: "GET OTP"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        transform: props.memberOnlyAccessError ? "translate(-43px, 85px)" : "translate(-43px, 112px)"
                                    },
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    className: "pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_DesktopView = (DesktopView);

// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(71778);
;// CONCATENATED MODULE: ./src/containers/MemberLogin/components/MobileView.js







var MobileView = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var mobileNumberInputRef = (0,react.useRef)();
    var otpInputRef = (0,react.useRef)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    (0,react.useEffect)(function() {
        if (isComponentMounted) {
            var ref, ref1;
            mobileNumberInputRef === null || mobileNumberInputRef === void 0 ? void 0 : (ref = mobileNumberInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            otpInputRef === null || otpInputRef === void 0 ? void 0 : (ref1 = otpInputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            return function() {
                document.getElementsByTagName("body")[0].style.overflowY = "auto";
            };
        }
    }, [
        isComponentMounted
    ]);
    var handleMobileInputChange = function(e) {
        props.handleInputChange("phone", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 10);
    };
    var handleOtpInputChange = function(e) {
        props.handleInputChange("otp", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 4);
    };
    var onContactUsClick = function() {
        var ref, ref1;
        (0,sendWhatsappMessage/* sendWhatsappMessage */.i)("Hi ".concat(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.store_name, ",\n\n                         I'm unable to access your website\n                         ").concat(props === null || props === void 0 ? void 0 : (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : ref1.store_url));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MemberLogin_module_default()).mobileView,
        children: props.OTPsent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.logo_image,
                            height: "40px",
                            width: "40px"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mv0 pt16px f16px fw6 c393939",
                            children: [
                                "Welcome to ",
                                (ref1 = props.storeInfo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store_info) === null || ref2 === void 0 ? void 0 : ref2.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-end justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mv0 f14px fw5 black-color pt34px",
                                    children: [
                                        "OTP sent to ",
                                        props.phone
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 f12px fw5 c2F80ED",
                                    onClick: props.toggleOTPsent,
                                    children: "Change number?"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: props.invalidOtp ? (MemberLogin_module_default()).formControlOtpInvalid : (MemberLogin_module_default()).formControlOtp,
                            value: props.OTP,
                            ref: otpInputRef,
                            placeholder: "Enter 4 Digit OTP",
                            onChange: handleOtpInputChange
                        }),
                        !props.isTimeUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (MemberLogin_module_default()).timerInProgress,
                            children: "0:".concat(props.timer)
                        }) : null,
                        props.isTimeUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (MemberLogin_module_default()).timerUp,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "c6C6C6C mv0 f12px",
                                    children: "Did not receive OTP?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 fw7 pt4px f12px pointer",
                                    onClick: function() {
                                        return props.resendOTP();
                                    },
                                    children: "Send OTP"
                                })
                            ]
                        }),
                        props.invalidOtp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (MemberLogin_module_default()).invalidOtp,
                            children: "Invalid OTP"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                    backgroundColor: props.OTP.length === 4 && !props.invalidOtp ? "#000000" : "#00000033",
                                    roundness: (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
                                    fluid: true,
                                    py: "15px",
                                    mt: "129px",
                                    pr: "4rem",
                                    pl: "3rem",
                                    fontSize: 18,
                                    style: {
                                        borderRadius: 100,
                                        borderWidth: "0px"
                                    },
                                    isDisable: props.OTP.length !== 4,
                                    onClick: function() {
                                        return props.submitVerifyOTP();
                                    },
                                    label: "Verify"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: "34%",
                                        right: "36%"
                                    },
                                    onClick: function() {
                                        return props.submitVerifyOTP();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: props === null || props === void 0 ? void 0 : (ref5 = props.storeInfo) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
                            height: "40px",
                            width: "40px"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mv0 pt16px f16px fw6 c393939",
                            children: [
                                "Welcome to ",
                                (ref6 = props.storeInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store_info) === null || ref7 === void 0 ? void 0 : ref7.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mv0 f14px fw5 black-color pt34px",
                            children: "Login using Mobile Number"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: (MemberLogin_module_default()).formControl,
                            value: props.phone,
                            ref: mobileNumberInputRef,
                            placeholder: "Enter your mobile Number",
                            onChange: handleMobileInputChange
                        }),
                        props.memberOnlyAccessError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start absolute",
                            style: {
                                top: 70
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/images/red-info-icon.svg",
                                    width: "12px",
                                    height: "12px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 f12px fw4 pl10px",
                                    style: {
                                        color: "#F54C52"
                                    },
                                    children: "Sorry, you don’t have permission to access this website."
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        marginTop: 94
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                    backgroundColor: props.phone.length === 10 && !props.memberOnlyAccessError ? "#000000" : "#00000033",
                                    roundness: (ref8 = props.storeInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness,
                                    fluid: true,
                                    style: {
                                        borderRadius: "2rem",
                                        borderWidth: "0px"
                                    },
                                    py: "15px",
                                    pr: "3rem",
                                    fontSize: 18,
                                    isDisable: props.phone && props.phone.length !== 10 || !props.phone || props.memberOnlyAccessError,
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    label: "Get OTP"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: "34%",
                                        right: "36%"
                                    },
                                    onClick: function() {
                                        return props.setPhoneNumber();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpRightArrow, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "c464646 f12px fw5 mv0 tc pt16px",
                            children: [
                                "For any query,",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "c2F80ED",
                                    style: {
                                        border: "none",
                                        cursor: "pointer",
                                        backgroundColor: "white"
                                    },
                                    onClick: onContactUsClick,
                                    children: "Contact us"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_MobileView = (MobileView);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(44779);
// EXTERNAL MODULE: ./src/utils/regex.js
var regex = __webpack_require__(36083);
;// CONCATENATED MODULE: ./src/containers/MemberLogin/index.js















var MemberLogin = function(param) {
    var storeInfo = param.storeInfo;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var width = (0,getWindowDimension/* default */.Z)().width;
    var timerID = null;
    var ref = (0,react.useState)({
        phone: "",
        OTP: "",
        OTPsent: false,
        timer: 59,
        isTimeUp: false,
        invalidOtp: false,
        currentDeviceWidth: 0,
        memberOnlyAccessError: false
    }), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.members_only_access)) router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        else {
            dispatch((0,user/* setLogout */.wt)());
            LocalStorageHelper/* default.delete */.Z["delete"]("auth_token");
        }
    }, []);
    (0,react.useEffect)(function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentDeviceWidth: width
            });
        });
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        if (state.OTPsent) {
            startTimer();
        }
        return function() {
            /** Clear the Inteeval if any */ if (timerID != null) {
                clearInterval(timerID);
            }
        };
    }, [
        state.OTPsent
    ]);
    var verifyOTPCallback = function(status) {
        if (status) {
            LocalStorageHelper/* default.add */.Z.add("isMemberAllowed&store_id=".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id), true);
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo.store_info.domain));
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    invalidOtp: true
                });
            });
        }
    };
    var validateInput = function(validationType) {
        switch(validationType){
            case "email":
                {
                    return (0,regex/* emailRegex */.HN)();
                }
            case "alpha_numeric":
                {
                    return (0,regex/* alphaNumericLettersRegex */.fw)();
                }
            case "alpha_space":
                {
                    return (0,regex/* alphabetsAndSpaceRegex */.PG)();
                }
            case "address":
                {
                    return (0,regex/* addressRegex */.L_)();
                }
            default:
                {
                    return /[^\d]/gi;
                }
        }
    };
    var handleInputChange = function(key, value, validationType, minLength, maxLength) {
        if (value.length > maxLength) value = value.substring(0, maxLength);
        value = value.replace(validateInput(validationType), "");
        if (!isNaN(value) && key === "phone") setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                phone: value,
                memberOnlyAccessError: false
            });
        });
        else if (!isNaN(value) && key === "otp") {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    OTP: value
                });
            });
            if (value.length < 4) {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        invalidOtp: false
                    });
                });
            }
        }
    };
    var setPhoneNumber = function() {
        var phoneReg = /(6|7|8|9)\d{9}/;
        if (state.phone && state.phone.length === 10 && state.phone.match(phoneReg)) {
            var ref;
            var queryParams = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.members_only_access) ? "&store_id=".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) : "";
            var callback = function(status) {
                if (status) setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        OTPsent: true
                    });
                });
                else setState(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        memberOnlyAccessError: true
                    });
                });
            };
            dispatch((0,auth/* generateOTP */.P)(state.phone, router, "web", queryParams, callback));
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Invalid Phone Number!");
        }
    };
    // Start the timmer
    var startTimer = function() {
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    // Increase the timing (second) tick
    var tick = function(seconds) {
        var updatedTime;
        if (seconds > 0) {
            updatedTime = (seconds < 10 ? "0" : "") + String(seconds);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    timer: updatedTime
                });
            });
        } else {
            clearInterval(timerID);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    timer: 59,
                    isTimeUp: true
                });
            });
        }
    };
    var resendOTP = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isTimeUp: false
            });
        });
        dispatch((0,auth/* generateOTP */.P)(state.phone));
        var seconds = state.timer;
        timerID = setInterval(function() {
            return tick(--seconds);
        }, 1000);
    };
    var handleChange = function(val) {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OTP: val
            });
        });
    };
    var submitVerifyOTP = function() {
        var data = {
            phone: state.phone,
            otp: state.OTP
        };
        if (state.OTP.length === 4) {
            dispatch((0,auth/* verifyOTP */.qD)(data, router, false, verifyOTPCallback));
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Please enter valid OTP");
        }
    };
    var toggleOTPsent = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OTPsent: !state.OTPsent,
                phone: "",
                timer: 59,
                isTimeUp: false,
                invalidOtp: false
            });
        });
    };
    var Props = {
        OTP: state.OTP,
        OTPsent: state.OTPsent,
        phone: state.phone,
        timer: state.timer,
        isTimeUp: state.isTimeUp,
        memberOnlyAccessError: state.memberOnlyAccessError,
        storeInfo: storeInfo,
        invalidOtp: state.invalidOtp,
        setPhoneNumber: setPhoneNumber,
        handleInputChange: handleInputChange,
        resendOTP: resendOTP,
        handleChange: handleChange,
        submitVerifyOTP: submitVerifyOTP,
        toggleOTPsent: toggleOTPsent
    };
    return state.currentDeviceWidth <= constants/* MAX_MOBILE_WIDTH */.Cf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileView, (0,_object_spread/* default */.Z)({}, Props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DesktopView, (0,_object_spread/* default */.Z)({}, Props));
};
/* harmony default export */ var containers_MemberLogin = (MemberLogin);


/***/ }),

/***/ 60227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ OrderContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var OrderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 36290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ sendWhatsappMessage; }
/* harmony export */ });
/* harmony import */ var src_utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30066);

var sendWhatsappMessage = function(message) {
    var speechInWords = encodeURIComponent(message || "");
    window.open((0,src_utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_0__/* .getWhatAppRedirectionUrl */ .gi)(speechInWords), "_blank");
};


/***/ }),

/***/ 71778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/*
  Returns isComponentMounted
  isComponentMounted -> true / Component is Successfully mounted
*/ function useIsComponentMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isComponentMounted = ref[0], setIsComponentMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsComponentMounted(true);
    }, []);
    return isComponentMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsComponentMounted);


/***/ }),

/***/ 91642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"desktopView":"MemberLogin_desktopView__ob3bF","formControl":"MemberLogin_formControl__nTHfH","formControlOtp":"MemberLogin_formControlOtp__8Csyq","formControlOtpInvalid":"MemberLogin_formControlOtpInvalid__X_DZ1","mobileView":"MemberLogin_mobileView__jFuaF","invalidOtp":"MemberLogin_invalidOtp__MiT6F","timerUp":"MemberLogin_timerUp__JEZ0o","timerInProgress":"MemberLogin_timerInProgress__e5L8V"};

/***/ })

}]);